import { SchemaType } from "../types";

export const NO_TRIGGER_TEXT: { [key in SchemaType]: string } = {
  normal: "Schema does not trigger on source entity type",
  partial: "Partial schemas cannot be tested on a source entity",
  index: "Index schema does not trigger on source entity type"
};

export const JSON_SCHEMA_OBSOLETE_CUTOFF_DATE = "2025-04-01";
